module.exports = __webpack_public_path__ + "img/logo.2d5c9335.png";